import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import NavBar from '../NavBar';
import Footer from '../sections/Footer';
import MotionVideo from '../components/motion/MotionVideo';
import { motionVideos } from '../data/motion';

export default function MotionPage() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
    const t = setTimeout(() => setVisible(true), 50);
    return () => clearTimeout(t);
  }, []);

  return (
    <div
      className={`bg-white min-h-screen flex flex-col transition-opacity duration-500 ${
        visible ? 'opacity-100' : 'opacity-0'
      }`}
    >
      <NavBar />

      <div className="flex-1 px-4 sm:px-8 md:px-16 lg:px-32 xl:px-[200px] 2xl:px-[250px] pt-28 md:pt-36 pb-[10vh]">
        {/* Back link */}
        <Link
          to="/"
          className="inline-flex items-center gap-2 font-poppins font-medium text-[14px] md:text-[16px] text-gray-500 hover:text-black transition-colors duration-200 mb-10 group"
        >
          <ArrowBackIcon
            className="transition-transform duration-200 group-hover:-translate-x-1"
            style={{ fontSize: '18px' }}
          />
          Back to Home
        </Link>

        {/* Header */}
        <div className="mb-[50px] md:mb-[60px]">
          <h1
            className="text-black font-poppins font-bold text-[32px] md:text-[48px] lg:text-[56px] leading-[40px] md:leading-[58px] lg:leading-[66px] mb-3"
            style={{ letterSpacing: '-0.4px' }}
          >
            Motion
          </h1>
          <p className="text-gray-600 font-normal font-poppins text-[15px] md:text-[17px] leading-[24px]">
            {motionVideos.length > 0
              ? `${motionVideos.length} ${motionVideos.length === 1 ? 'piece' : 'pieces'}`
              : 'First pieces are on the way.'}
          </p>
        </div>

        {/* Gallery */}
        {motionVideos.length > 0 ? (
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8">
            {motionVideos.map((video) => (
              <article key={video.id} className="flex flex-col gap-4">
                <MotionVideo
                  src={video.src}
                  poster={video.poster}
                  title={video.title}
                  className="aspect-video rounded-2xl"
                />
                <div className="flex flex-col gap-1">
                  <div className="flex items-baseline justify-between gap-4">
                    <h2 className="font-poppins font-bold text-[18px] md:text-[20px] text-black">
                      {video.title}
                    </h2>
                    {video.year && (
                      <span className="font-poppins text-[13px] text-gray-500 flex-shrink-0">
                        {video.year}
                      </span>
                    )}
                  </div>
                  {video.description && (
                    <p className="font-poppins text-[14px] md:text-[15px] leading-[22px] text-gray-700">
                      {video.description}
                    </p>
                  )}
                  {video.tools?.length > 0 && (
                    <p className="font-poppins text-[12px] md:text-[13px] text-gray-500">
                      {video.tools.join(' · ')}
                    </p>
                  )}
                </div>
              </article>
            ))}
          </div>
        ) : (
          <div className="rounded-2xl border border-dashed border-gray-300 p-10 md:p-16 text-center font-poppins text-gray-500">
            Nothing here yet. Check back soon.
          </div>
        )}
      </div>

      <Footer />
    </div>
  );
}
